exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* Neutralise l'espace vide de layout sur la vue CGU */\n.app-container.cgu,\r\n.app-container.cgu main,\r\n.app-container.cgu #main {\r\n    min-height: 0 !important;\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.cgu .view-container {\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\r\n/* Cache le footer global pour garder uniquement le footer custom de CGU */\n.app-container.cgu .footer-component {\r\n    display: none !important;\n}\r\n", ""]);

// exports
